import React from 'react';
import RouteUrls from './RouteUrls';
import SigninComponent from '../Containers/Signin/Signin';

const RewardPageContainer = React.lazy(() =>
  import('../Containers/RewardPage/RewardPageContainer')
);
const CategoryPageContainer = React.lazy(() =>
  import('../Containers/CategoryPage/CategoryPageContainer')
);
const PiggyBankBalancePageContainer = React.lazy(() =>
  import('../Containers/PiggyBankBalancePage/PiggyBankBalancePageContainer')
);

const RewardDashboardPageContainer = React.lazy(() =>
  import('../Containers/RewardDashboardPage/RewardDashboardPageContainer')
);

const PiggyBankTransactionPageContainer = React.lazy(() =>
  import('../Containers/PiggyBankTransactionPage/PiggyBankTransactionPageContainer')
);
const AboutPageContainer = React.lazy(() => import('../Containers/AboutPage/AboutPageContainer'));

const SignUpComponent = React.lazy(() => import('../Containers/SignUp/SignUp'));
const NotFoundComponent = React.lazy(() => import('../Components/NotFound/NotFoundComponent'));
const AppHomeContainer = React.lazy(() => import('../Containers/AppHome/AppHomeContainer'));

const ProfilePageContainer = React.lazy(() =>
  import('../Containers/ProfilePage/ProfilePageContainer')
);

const ReedemPageContainer = React.lazy(() => import('../Containers/RedemPage/RedemPageContainer'));
const ForgotPasswordComponent = React.lazy(() =>
  import('../Containers/ForgotPassword/ForgotPassword')
);
const EmailSentConfirmationScreen = React.lazy(() =>
  import('../Containers/ForgotPassword/EmailSentConfirmationScreen')
);
const ResetPasswordComponent = React.lazy(() =>
  import('../Containers/ForgotPassword/ResetPassword')
);
const PasswordChangeSuccessComponent = React.lazy(() =>
  import('../Containers/ForgotPassword/PasswordChangeSuccess')
);
const LinkExpiredScreen = React.lazy(() => import('../Containers/ResetPassword/LinkExpiredScreen'));
const EmailVerificationComponent = React.lazy(() =>
  import('../Components/EmailVerification/EmailVerification')
);

const SettingsComponent = React.lazy(() => import('../Containers/Settings/Settings'));

const Routes = [
  {
    path: RouteUrls.appHome,
    exact: true,
    component: AppHomeContainer
  },
  {
    path: RouteUrls.home,
    exact: true,
    component: AppHomeContainer
  },
  {
    path: RouteUrls.login,
    exact: true,
    component: SigninComponent
  },
  {
    path: RouteUrls.signup,
    exact: true,
    component: SignUpComponent
  },
  {
    path: RouteUrls.reward,
    exact: true,
    component: RewardPageContainer
  },
  {
    path: RouteUrls.categories,
    exact: true,
    component: CategoryPageContainer
  },
  {
    path: RouteUrls.piggyBankBalance,
    exact: true,
    component: PiggyBankBalancePageContainer
  },
  {
    path: RouteUrls.piggyBankTransactions,
    exact: true,
    component: PiggyBankTransactionPageContainer
  },
  {
    path: RouteUrls.rewardDashboard,
    exact: true,
    component: RewardDashboardPageContainer
  },
  {
    path: RouteUrls.aboutPage,
    exact: true,
    component: AboutPageContainer
  },
  {
    path: RouteUrls.profile,
    exact: true,
    component: ProfilePageContainer
  },
  {
    path: RouteUrls.reedem,
    exact: true,
    component: ReedemPageContainer
  },
  {
    path: RouteUrls.forgotPassword,
    exact: true,
    component: ForgotPasswordComponent
  },
  {
    path: RouteUrls.checkEmail,
    exact: true,
    component: EmailSentConfirmationScreen
  },
  {
    path: RouteUrls.resetPassword,
    exact: true,
    component: ResetPasswordComponent
  },
  {
    path: RouteUrls.linkExpired,
    exact: true,
    component: LinkExpiredScreen
  },
  {
    path: RouteUrls.passwordChangeSuccess,
    exact: true,
    component: PasswordChangeSuccessComponent
  },
  {
    path: RouteUrls.emailVerification,
    exact: true,
    component: EmailVerificationComponent
  },
  {
    path: RouteUrls.settings,
    exact: true,
    component: SettingsComponent
  },
  {
    path: '*',
    component: NotFoundComponent
  }
];

export default Routes;
